import angular from 'angular';

/* @ngInject */
class FormResponses {
	constructor(FormService) {
		this.FormService = FormService;
	}

	validate(elements) {
		let errors = [];

		angular.forEach(elements, (element, index) => {
			const elementTypeAttributes = this.FormService.getElementTypeAttributes()[element.type];

			const label = (element.label && element.label.length !== 0) ? (`"${element.label}"`) : (`${index + 1} (${elementTypeAttributes.type.name})`);

			if (element.responseValue) {
				switch (element.type) {
					case 'input-captcha': {
						// TODO: Implement checking

						break;
					}

					case 'input-checkbox': {
						const values = Object.keys(element.responseValue)
						                     .filter((key) => {
							                     return element.responseValue[key];
						                     });

						if (element.required && values.length === 0) {
							errors.push(`You must check at least 1 value for element ${label}.`);
						}

						break;
					}

					case 'input-dropdown': {


						break;
					}

					case 'input-datetime': {


						break;
					}

					case 'input-document-upload': {


						break;
					}

					case 'input-hidden': {


						break;
					}

					case 'input-multiline': {


						break;
					}

					case 'input-numerical': {


						break;
					}

					case 'input-radio': {


						break;
					}

					case 'input-text': {


						break;
					}

					default: {
						break;
					}
				}
			} else {
				if (element.required) {
					errors.push(`You must provide a value for element ${label}.`);
				}
			}
		});

		return errors;
	}

	getPostableResponse(input) {
		return {
			version:  input.id,
			elements: [
				...input.elements.filter((element) => {
					        return element.type.startsWith('input-');
				        })
				        .map((element) => {
					        let output = {
						        element: element.id,
						        value:   (element.responseValue !== undefined) ? (element.responseValue) : (null),
					        };
					        if (output.value !== null) {
						        switch (element.type) {
							        case 'input-captcha': {


								        break;
							        }

							        case 'input-checkbox': {
								        output.value = Object.keys(element.responseValue)
								                             .filter((key) => {
									                             return element.responseValue[key];
								                             });

								        break;
							        }

							        case 'input-dropdown': {


								        break;
							        }

							        case 'input-datetime': {


								        break;
							        }

							        case 'input-document-upload': {


								        break;
							        }

							        case 'input-hidden': {


								        break;
							        }

							        case 'input-multiline': {


								        break;
							        }

							        case 'input-numerical': {


								        break;
							        }

							        case 'input-radio': {


								        break;
							        }

							        case 'input-text': {


								        break;
							        }

							        default: {
								        break;
							        }
						        }
					        }

					        return output;
				        }),

			],
		};
	}
}

export default FormResponses;


// WEBPACK FOOTER //
// ./src/js/services/formResponses/index.js